import React from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline'

import { LIVE_MUSIC, SERVICE, MUSICIAN, BAND } from "../../../../consts";

// components

// svgs
import fbShareWhiteSVG from '../../../inlineSVGs/fbShareWhiteSVG';


// styles
import './MediaTop.css';

const MediaTop = ({ type, styles = [], wrapperStyle, onShareClick = () => {} }) => {
    return (
        <div className="modal-media-top-wrapper" style={wrapperStyle}>
            <div className="style-wrapper">
                {styles.map((s, i) => <label key={`style-label-${i}`} className={`label ${type}`}>{s}</label> )}
            </div>
            <SVGInline className="share-icon-media-top" svg={fbShareWhiteSVG} component="i" onClick={onShareClick}/>
        </div>
    )
};

MediaTop.propTypes = {
    type: PropTypes.oneOf([LIVE_MUSIC, SERVICE, MUSICIAN, BAND]),
    styles: PropTypes.array,
    wrapperStyle: PropTypes.object,
    onShareClick: PropTypes.func
};

export default MediaTop;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/MediaTop/MediaTop.js